// HomePill.js
// Bordered pill button used for launcher grids (STEM Missions, Summer Camp
// days). `current` highlights the pill with a brand border + soft fill.
import React from "react";
import { Pressable, Text, StyleSheet } from "react-native";
import { MaterialCommunityIcons } from "@expo/vector-icons";

import { homeColors } from "../homeTheme";

const HomePill = ({
  icon = null,
  label,
  note = null,
  current = false,
  onPress = null,
  isDarkMode = false,
  testID,
}) => {
  const colors = homeColors(isDarkMode);

  return (
    <Pressable
      testID={testID}
      onPress={onPress || undefined}
      accessibilityRole="button"
      accessibilityLabel={label}
      style={[
        styles.pill,
        {
          borderColor: current ? colors.brand : colors.line,
          backgroundColor: current ? colors.brandSoft : colors.cardBg,
        },
      ]}
    >
      {icon ? (
        <MaterialCommunityIcons
          name={icon}
          size={16}
          color={current ? colors.brand : colors.textSecondary}
        />
      ) : null}
      <Text style={[styles.label, { color: colors.textPrimary }]}>{label}</Text>
      {note ? (
        <Text style={[styles.note, { color: colors.ink3 }]}>{`· ${note}`}</Text>
      ) : null}
    </Pressable>
  );
};

const styles = StyleSheet.create({
  pill: {
    flexDirection: "row",
    alignItems: "center",
    gap: 6,
    borderWidth: 1,
    borderRadius: 999,
    paddingVertical: 8,
    paddingHorizontal: 12,
  },
  label: { fontSize: 13, fontWeight: "600" },
  note: { fontSize: 12 },
});

export default HomePill;
